import React from 'react';
import { ContentfulArticle } from '@jbhi-fi/apis/src/contentful/types';
import { ContentCardCoverImage } from '../../ContentCard';
import { CardGridCardProps } from '../../ContentCard/CardGrid/CardGrid';
import { format, parseISO } from 'date-fns';
import { CardTransformer } from './CardTransformer';
import { QuickSearchContentProps } from '../../QuickSearchContent/QuickSearchContent';
import { ContentfulImage } from '../../ContentfulImage/ContentfulImage';
import { AssetTransformer } from './AssetTransformer';

export abstract class ArticleTransformer {
  static toCardProps = (entry?: ContentfulArticle): CardGridCardProps => {
    const isVideoCard = Boolean(entry?.fields?.heroVideo?.fields);
    const coverImageProps = CardTransformer.toCardCoverImageProps(entry);
    const publishedDate = entry?.fields?.publishedDate || entry?.sys?.createdAt;
    return {
      heading: entry?.fields?.heading,
      content: !isVideoCard ? entry?.fields?.intro : null,
      cover: coverImageProps ? <ContentCardCoverImage {...coverImageProps} /> : null,
      tagProps: CardTransformer.toTagProps(entry),
      footerProps: {
        leftContent: publishedDate ? format(parseISO(publishedDate), 'd MMM yyyy') : '',
        rightContent: entry?.fields?.subCategoryPage?.fields?.heading,
      },
      showTag: false,
      href: CardTransformer.toHref(entry),
    };
  };

  static toQuickSearchCardProps = (entry?: ContentfulArticle): QuickSearchContentProps => {
    const coverImageProps = AssetTransformer.toContentfulImageProps(entry?.fields?.heroImage);
    return {
      title: entry?.fields?.heading || '',
      image: <ContentfulImage {...coverImageProps} sizes="80px" aspectRatio={1} />,
      destinationUrl: CardTransformer.toHref(entry),
    };
  };
}
